<ng-container *ngrxLet="hideWorkingCondition$ as hideWorkingCondition">
  <div class="mt-2 mb-3">
    <apm-section-title icon="t_units" [removeBottomMargin]="true" [title]="sectionTitle()">
      @if (showActions() && subCategoryId()) {
        <apm-icon
          class="d-inline-block me-2"
          size="md"
          [icon]="!hideWorkingCondition ? 'a_full_screen' : 'a_small_screen'"
          [isButton]="true"
          (iconClick)="toggleStudy()"
          matTooltip="{{ (!hideWorkingCondition ? '445075' : '445077') | apmTranslate }}"
        ></apm-icon>
      }
      @if (unitWithAccessories.length > 0) {
        <apm-icon
          class="d-inline-block me-2"
          size="md"
          icon="aa_alert_filter"
          [isButton]="true"
          (iconClick)="openPerformanceAssignmentDialog()"
          matTooltip="{{ '445155' | apmTranslate }}"
        ></apm-icon>
      }
      @if (showActions() && subCategoryId()) {
        <apm-icon
          class="d-inline-block me-2"
          size="md"
          icon="a_download"
          [isButton]="true"
          [hasHoverIcon]="true"
          (iconClick)="exportTableCsv()"
          matTooltip="{{ '445154' | apmTranslate }}"
        ></apm-icon>
      }
      @if (showActions()) {
        <apm-icon
          class="d-inline-block"
          size="md"
          icon="a_add"
          [isButton]="true"
          [hasHoverIcon]="true"
          (iconClick)="goToModelSearch()"
          matTooltip="{{ '445151' | apmTranslate }}"
        ></apm-icon>
      }
      @if (showActions() && selectedRows.length > 0) {
        <apm-icon
          class="d-inline-block ms-2"
          size="md"
          icon="a_delete"
          [isButton]="true"
          [hasHoverIcon]="true"
          (iconClick)="deleteUnits()"
          matTooltip="{{ '444841' | apmTranslate }}"
        ></apm-icon>
      }
      @if (isFromStudy() && isInterimStudy()) {
        <apm-icon
          class="d-inline-block ms-2"
          size="md"
          icon="a_multi_add"
          [isButton]="true"
          [hasHoverIcon]="true"
          [disabled]="hasInvalidUnits()"
          (iconClick)="addAllUnits()"
          matTooltip="{{ 444738 | apmTranslate }}"
        ></apm-icon>
      }
    </apm-section-title>
  </div>

  <div
    class="study-models-table compressed-table"
    [ngClass]="{ 'by-subcategory': !!subCategoryId() && !hideWorkingCondition }"
  >
    <apm-table
      #table
      [rowHeight]="40"
      [gridId]="uniqueGridId()"
      [rowData]="unitPerformanceRows()"
      [columnDefs]="columnsReady() ? columnDefs : []"
      [persistColumnState]="true"
      [persistFilterState]="true"
      [suppressRowTransform]="true"
      [postSortRows]="postSortRowsByUnits"
      [getRowStyle]="getRowStyle"
      [animateRows]="false"
      [hideExportContextMenuOption]="true"
      (action)="onAction($event)"
      (selectionChanged)="setSelectedRow($event)"
      (filterReset)="onFiltersReset()"
      (filterChanged)="onFilterChanged($event)"
      (rowDataUpdated)="onRowDataUpdated($event)"
      rowSelection="multiple"
    ></apm-table>
  </div>
</ng-container>
